import { useQuery } from '@tanstack/react-query';
import groq from 'groq';
import { SLUG } from 'lib/queries';
import { client } from 'lib/sanity';
import type { Slugs } from 'types/cms/Slugs';

export const PROMOTIONS_KEY = 'promotions';

export const fetchPromotions = async () => {
  const query = groq`
    *[ _type == 'timeline_promotion']{
      ${SLUG},
    }
	`;

  const promotions: Slugs = await client.fetch(query);
  return promotions;
};

export const usePromotions = () =>
  useQuery({ queryKey: [PROMOTIONS_KEY], queryFn: fetchPromotions });
